import { PubSub, PubSubCallback } from '@instinet-analytics/core-lib';
import { LoggingService } from '@instinet-analytics/core-lib';
import { Logger, buildLogger } from '@instinet-analytics/core-lib';
import { v4 as uuid } from 'uuid';
import {
    FilteredPortfolioChangedEventType,
    FilteredPortfolioChangedEventUpdates,
} from './store/actions';

export interface FilteredPortfolioChanged {
    changedType: FilteredPortfolioChangedEventType;
    batchUpdateInProgress?: boolean;
    /*
     * If the type is UPDATED, this has details of the updates
     */
    updates?: FilteredPortfolioChangedEventUpdates;
}

export class PortfolioEventService {
    private filteredPortfolioEventBus: PubSub<FilteredPortfolioChanged>;
    private logger: Logger;

    public constructor(private loggingService: LoggingService) {
        this.filteredPortfolioEventBus = new PubSub<FilteredPortfolioChanged>();
        this.logger = buildLogger('PortfolioEventService', this.loggingService);
    }

    public publishFilteredPortfolioChanged(ev: FilteredPortfolioChanged) {
        this.logger.debug(
            'Publishing filtered portfolio changed',
            sanitise(ev)
        );
        this.filteredPortfolioEventBus.publish(ev);
    }

    public subscribeFilteredPortfolioChanged(
        cb: PubSubCallback<FilteredPortfolioChanged>
    ) {
        return this.filteredPortfolioEventBus.subscribe(uuid(), cb);
    }
}

function sanitise(ev: FilteredPortfolioChanged) {
    return {
        changedType: ev.changedType,
        batchUpdateInProgress: ev.batchUpdateInProgress,
        added: ev.updates?.added.length,
        removed: ev.updates?.removed.length,
        updated: ev.updates?.updated.length,
    };
}
